var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.744323 0.560208C0.895265 0.371531 1.17058 0.34094 1.35926 0.491882L4.00262 2.60657L6.64598 0.491882C6.83466 0.34094 7.10998 0.371531 7.26092 0.560208C7.41186 0.748885 7.38127 1.0242 7.19259 1.17514L4.27592 3.50848C4.11614 3.6363 3.8891 3.6363 3.72932 3.50848L0.81265 1.17514C0.623972 1.0242 0.593382 0.748885 0.744323 0.560208Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f502b6c8c6f713e6fcdc5cf1a9052244.svg";
export { ForwardRef as ReactComponent };